import { render, staticRenderFns } from "./DeliveryPeriod.vue?vue&type=template&id=eb0a972e&scoped=true"
import script from "./DeliveryPeriod.vue?vue&type=script&lang=js"
export * from "./DeliveryPeriod.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPeriod.vue?vue&type=style&index=0&id=eb0a972e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0a972e",
  null
  
)

export default component.exports